export default __webpack_public_path__ + "static/media/tqicon-7.00e69118.svg";